import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

export const RestroUserLogData = {
  getAll: async () => {
    try {
      console.log("fired")
      const response = await instance.get("restrouserslogs/getlist");
      // console.log("DataManagement Response:", response.data);
      return response.data;
    } catch (error) {
      console.error( error);
      throw error;
    }
  },
  getByApiKey: async (apiKey) =>{
    try{
      const response = await instance.get(`/restrouserslogs/getlogsbyapikey/${apiKey}`)
      return response.data;
    }catch(err){
      console.error(err)
      throw err;
    }
  }
}

